import { BreakpointSize } from '../models/breakpoint/breakpoint-size.type';

export const BreakpointWidth: Record<BreakpointSize, number> = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1280,
};
